import { TOURS_LIST_SET_PRODUCT_TYPE } from "../search/types";
import _ from "lodash";

import { autocompletePOI } from "../../api";
import { AUTOCOMPLETE_RESET_DATA, AUTOCOMPLETE_SAVE_DATA } from "./types";
import { pkgSearch, toursSearch } from "../search";

const saveAutoCompleteData = (data) => {
  return { type: AUTOCOMPLETE_SAVE_DATA, data };
};

export const resetAutoCompleteData = () => {
  return { type: AUTOCOMPLETE_RESET_DATA };
};

export const autoCompletePOI = (query) => async (dispatch) => {
  const result = await autocompletePOI(query);
  dispatch(saveAutoCompleteData(_.get(result, "pois", [])));
};

export const redirectToPackageList = (history) => (dispatch) => {
  dispatch({ type: TOURS_LIST_SET_PRODUCT_TYPE, product_type: "PKG" });
  dispatch(pkgSearch({ redirect: false, history }));
  history.push("/tours/");
};

export const redirectToAddOnList = (history) => (dispatch) => {
  dispatch({ type: TOURS_LIST_SET_PRODUCT_TYPE, product_type: "MI" });
  const theme = "";
  dispatch(toursSearch(theme));
  history.push("/tours/");
};
